import { useState } from "react";
import { toast } from "react-toastify";
import { callApi } from "../../api";
import { useAuth } from "../useAuth";

const LOADING_TYPES = {
  FETCH_AGG_DATA: "fetch_agg_data",
};

const useAggregateReports = () => {
  const { selectedBusiness } = useAuth();
  const [loading, setLoading] = useState(null);
  const [aggregateReports, setAggregateReports] = useState([]);

  const getAggregateReports = async (startDate, endDate) => {
    setLoading(LOADING_TYPES.FETCH_AGG_DATA);
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/sales?start=${startDate}&end=${endDate}`
    );
    if (res && res.status === true) {
      setAggregateReports(res.data);
    } else {
      toast.error((res && res.message) || "Failed to fetch aggregate sales!");
    }
    setLoading(null);
    return res.data || [];
  };

  return {
    aggregateReports,
    getAggregateReports,
    loadingFetch: loading === LOADING_TYPES.FETCH_AGG_DATA,
  };
};

export default useAggregateReports;
